import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { takeSessionEndReason } from "../../commonFunctions/session";
import { useForm } from "react-hook-form";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import {
  callAPI,
  clearRequest,
  LoacalVariables,
  Method,
  setLocalValues,
} from "../../commonFunctions/CommonFunctions";
import backImg from "../../images/Rectangle.svg";
// import logo from "../../images/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import doctorImage from "../../images/melp-doctor-login-logo.svg";
import logo from "../../images/melplogo1.svg";

import backgroundImage1 from "../../images/bg2.svg";
import WSSelectField from "../../Components/Select/WSSelect";
import config from "../../Config/clientConfig.json";
interface LoginFormProps {
  onLogin: (token: string) => void;
}

export const VendorLoginForm: React.FC<LoginFormProps> = React.memo(
  ({ onLogin }) => {
    const {
      control,
      register,
      handleSubmit,
      formState: { errors },
    } = useForm();
    const { showMessage } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Explain an automatic logout (idle timeout or expired login)
    useEffect(() => {
      const reason = takeSessionEndReason();
      if (reason === "idle") {
        showMessage("You were logged out after a period of inactivity. Please log in again.", "warning");
      } else if (reason === "expired") {
        showMessage("Your session has expired. Please log in again.", "warning");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleData = async (data: any) => {
      console.log("data", data);

      try {
        const request = {
          userName: data.userName,
          password: data.password,
          loginType: data.loginType,
        };
        console.log("requ is", request);

        const newRequest = clearRequest(request);

        setLoading(true);
        const response: any = await callAPI(
          "Auth/login",
          Method.POST,
          newRequest
        );
        console.log("response after loginc", response);

        if (response && response?.data?.accessToken) {
          console.log("yes havef token", response.data);
          setLocalValues(LoacalVariables.UserId, response?.data?.id);
          console.log("step 3", response.data.accessToken);

          //  const name = `${response?.firstName} ${response?.lastName ? response?.lastName : ''} `
          setLocalValues(LoacalVariables.Name, response?.data?.name);
          const profileResponse: any = await callAPI(
            "VendorProfile/user",
            Method.GET,
            null,
            response?.data?.id
          );
          console.log("profile response", profileResponse);
          const userResponse: any = await callAPI(
            "Auth",
            Method.GET,
            null,
            response?.data?.id
          );
          console.log("user response", userResponse);

          if (userResponse) {
            setLocalValues(LoacalVariables.Phone, userResponse?.mobileNumber);
            setLocalValues(LoacalVariables.Name, userResponse?.name);
            setLocalValues(LoacalVariables.UserId, userResponse?.id);
            setLocalValues(LoacalVariables.UserType, userResponse.userType);
            setLocalValues(LoacalVariables.Email, userResponse?.email);

          }

          console.log("try to make login", response.data.accessToken);
          onLogin(response?.data?.accessToken);

          if (profileResponse?.success === false) {
            navigate("/register/profile");
            return;
          }

          showMessage("Logged in successfully!", "success");
        }
      } catch (e: any) {
        console.log('e message', e)
        showMessage(e.response?.data?.message || "An unexpected error occurred.", "error");
      } finally {
        setLoading(false);
      }
    };

    return (
      <Grid item container>
        <Grid
          container
          sx={{
            position: "relative",
            backgroundImage: `url(${backImg})`,
            backgroundSize: "cover",
            backgroundColor: "#022219",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            minHeight: "100vh",
            justifyContent: "center",
            alignItems: "center",
            padding: 2,
          }}
        >
          {" "}
          <Box
            component="img"
            src={logo}
            alt="MELP Logo"
            sx={{
              position: "absolute",
              top: 24,
              left: 54,
              width: 100,
              zIndex: 10,
            }}
          />
          <Grid
            container
            sx={{
              position: "relative",
              minHeight: "80vh",
              backgroundImage: `url(${backgroundImage1})`,
              border: "1px solid #022219",
              borderRadius: 5,
              backgroundSize: "cover",
              backgroundColor: "#022219",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              justifyContent: "center",
              alignItems: "center",
              width: "80%",
              padding: 7,
            }}
          >
            <form onSubmit={handleSubmit(handleData)}>
              <Box
                sx={{
                  backgroundColor: "white",
                  padding: "30px",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  maxWidth: "400px",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <img src={doctorImage} height={150}></img>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  style={{ color: "#098963" }}
                >
                  Welcome Back <span style={{ color: "#098963" }}></span>
                </Typography>
                <Typography variant="body2" color="#098963" sx={{ mb: 2 }}>
                  ️Let’s Get Started
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <WSTextField
                      label="User Name"
                      {...register("userName", {
                        required: "User Name is required",
                      })}
                      id="userName"
                      name="userName"
                      control={control}
                      //  maxLength={10}
                      textIcon="Person"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <WSTextField
                      label="Password"
                      {...register("password", {
                        required: "Password is required",
                      })}
                      id="password"
                      name="password"
                      control={control}
                      textIcon="Password"
                      type={TextType.Password}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <WSSelectField
                      rules={{ required: true }}
                      {...register("loginType")}
                      id="loginType"
                      control={control}
                      label="Login Type"
                      name="loginType"
                      isInGridFilter={false}
                      options={config.loginTypeConfig.staticOptionData}
                      defaultValue={"Lab"}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{
                        backgroundColor: "#098963",
                        color: "white",
                        padding: "10px",
                        borderRadius: "8px",
                        mt: 0,
                        "&:hover": {
                          backgroundColor: "#379e80", // Change to any color you like
                        },
                      }}
                      disabled={loading}
                    >
                      {loading ? "Logging in..." : "Login"}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      textAlign="center"
                    >
                      Don’t have an account?{" "}
                      <Link
                        to="/register"
                        style={{
                          textDecoration: "none",
                          color: "#098963",
                          fontWeight: 500,
                        }}
                      >
                        Register
                      </Link>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Grid>
    );
  }
);
